export default function formatCurrency(
  amount: Maybe<number | string>,
  currency = 'EUR',
): string | undefined {
  if (amount === undefined || amount === null) return undefined;

  const currencyToLocaleMap: Record<string, string> = {
    USD: 'en-US',
    ANG: 'nl-CW',
    XCG: 'nl-CW',
    EUR: 'nl-BE',
  };

  const locale = currencyToLocaleMap[currency];
  if (!locale) return `${currency} ${amount}`;

  let formattedAmount = Number(amount).toLocaleString(locale, {
    style: 'currency',
    currency: currency,
  });

  if (currency === 'ANG')
    formattedAmount = formattedAmount.replace(/NAf\./g, 'ƒ');

  return formattedAmount;
}
